import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { ConnectorAction } from "stores/Connector/ConnectorAction";
const mapStateToProps = (state) => {
  
  return {
    ConnectorDataList: state.ConnectorData.ConnectorDataList,
    postConnectorList: state.ConnectorData.postConnectorList,
    postConnectorBulkList: state.ConnectorData.postConnectorBulkList,
    isLoading:state.ConnectorData.Connectordataloading.isLoading
   
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getConnectorData: ConnectorAction.getConnectorData,
postConnectorData: ConnectorAction.postConnectorData,
postBulkData: ConnectorAction.postBulkData,
deleteconnectorsAction:ConnectorAction.deleteconnectors,
toastAction : commonActions.setSnackbarAction
}, dispatch);
const ConnectorTypeStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default ConnectorTypeStore;
 